import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { Store } from '../_core/types/Store';
import { analytics } from '../analyticStore/constants/analytics';
import useApiStore from '../apiStore/useApiStore';
import useAttributionStore from '../attributionStore/useAttributionStore';
import useLeadChannelStore from '../leadChannelStore/useLeadChannelStore';
import { trackingPixelStore } from './trackingPixelStore';
import { TrackingPixelState } from './types/TrackingPixelState';

const useTrackingPixelStore: Store<TrackingPixelState> =
  createStore<TrackingPixelState>({
    creator: trackingPixelStore({
      analytics,
      targetEnvironment: import.meta.env.VITE_APP_TARGET_ENVIRONMENT,
      useApiStore: lazyDependency(() => useApiStore),
      useAttributionStore: lazyDependency(() => useAttributionStore),
      useLeadChannelStore: lazyDependency(() => useLeadChannelStore),
    }),
    id: 'trackingPixel',
    // the pages already counted must survive the sign-out reset
    ignoreReset: true,
    middlewares: {
      devtools: true,
    },
  });

export default useTrackingPixelStore;
